import { createFileRoute } from '@tanstack/react-router';

import { Help } from '@/features/registration';

export const Route = createFileRoute('/help')({
	component: () => <Help />,
	head: () => ({
		meta: [
			{
				title: 'Need help? | ACCESS Research Platform',
			},
		],
	}),
});
